module.exports = __webpack_public_path__ + "static/media/48415362_2308755952532916_2614024457643098112_o-thumb.93e4a0a9.jpg";